import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const linkContent = css`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 1px 8px;
    border-radius: 18px;
    background-color: transparent;
    color: var(--brand-6);
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;

    :hover,
    :active,
    :focus {
        background-color: var(--gray-4);
    }
`;

export const SingleLink = styled(Link)`
    ${linkContent}
`;

export const LinksPill = styled.button`
    ${linkContent}
    border: none;
    cursor: pointer;
`;

export const PopoverBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
`;

export const PopoverMessage = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--gray-8);
    white-space: nowrap;
`;

export const RowLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--brand-5);
    white-space: nowrap;

    :hover,
    :active {
        color: var(--brand-7);
    }
`;

export const RowType = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 22px;
`;

export const StatusDot = styled.span<{ $color: string }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
`;

export const DucrLabel = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 22px;
`;

export const DucrValue = styled.span`
    font-size: 12px;
    line-height: 20px;
`;
